import React from "react"
import Hero from "./Hero"
import { getFront, getQuizes } from '../utils/api'
import Container from "./Container"
import FinishPage from "./FinishPage"
import QuizesContent from './QuizContent';
import FaqContent from './FaqContent'
import MainImg from '../images/main_img.png';

const Switch = props => {
  const { value, children } = props
  // filter out only children with a matching prop
  return children.find(child => {
    return child.props.value === value
  })      
}

let HeroBlock = ({frontpageObject, toQuiz}) => {


  return (
    <>
      <div className='text-block text-block_pink main-section__text-block'
        dangerouslySetInnerHTML={{__html: frontpageObject.acf.text}}
      />
      <div className="main-section__link">
        <button onClick={toQuiz}>
          <span
            dangerouslySetInnerHTML={{__html: frontpageObject.acf.button_text}}
          />
        </button>
      </div>
    </>
  )
}
export default class Quizes extends React.Component{

  state = {
    quizArray: null,
    completedQuiz: [],
    activeQuiz: null,
    isFinished: false,
    frontpageObject: null,
    gap: false,
    checkedAnswers: {},
    scores: {},
    companyDetail: '',
    homepage: true
  }


  componentDidMount(){
    
    getFront().then(( frontpageObject ) => {
      getQuizes().then(( quizArray ) => {
        this.setState(({
          frontpageObject,
          quizArray
        }))
      })
    })    
  }

 

  handleChangeTextarea = (value) => {
    this.setState({
      companyDetail: value
    })
  }


  handleChangeAnswers = (k, score_name, score, input_name, value) => {
    let newScores = this.state.scores;
    let newcheckedAnswers = this.state.checkedAnswers;

    newScores[score_name] === undefined ? newScores[score_name] = {[k + 1] : score}  : newScores[score_name][k + 1] = score
    newcheckedAnswers[input_name] = value

    this.setState(({
      scores: newScores,
      checkedAnswers: newcheckedAnswers
    }))
  }

  changeQuiz = (id) => {
    this.setState(({
      activeQuiz: id,
      isFinished: false,
      gap: false,
      homepage: false
    }))
  }

  completeQuiz = (e, id, status, activeTab, isFinished = false) => {
    e.preventDefault();
    

    if(status !== true){
      status = this.state.completedQuiz[id] !== undefined 
      ? this.state.completedQuiz[id].status
      : false
    } 
    let completedQuiz = this.state.completedQuiz
        
    let gap = activeTab !== false ? false : true
    
    if(activeTab !== false && this.state.checkedAnswers[id + '_' + (activeTab)] === undefined){
      activeTab = activeTab === 0 ? 1 : activeTab
      
      while(this.state.checkedAnswers[id + '_' + (activeTab - 1)] === undefined){
        activeTab = activeTab - 1;
    
        if(activeTab == 0){
          break
        }
      
      }
    }

    completedQuiz[id] = {status, activeTab}
    

    this.setState(({
      completedQuiz,
      gap,
      isFinished
    }))
  }


  render(){
    
    let { homepage, quizArray, completedQuiz, activeQuiz, isFinished, frontpageObject, gap, checkedAnswers, scores, companyDetail } = this.state;
 
    return (
      <React.Fragment>
        {
          isFinished === true && <FinishPage checkedAnswers={checkedAnswers} companyDetail={companyDetail}  quizArray={quizArray} completedQuiz={completedQuiz} frontpageObject={frontpageObject} scores={scores}/>
        }

{
          activeQuiz !== null && isFinished === false && frontpageObject !== null
            && <Container 
                frontpageObject={frontpageObject} 
           
            >
              <QuizesContent  
                  changeQuiz={this.changeQuiz}
                  completeQuiz={this.completeQuiz} 
                  activeQuiz={activeQuiz} 
                  quizArray={quizArray} 
                  gap={gap}
                  handleChangeAnswers={this.handleChangeAnswers}
                  handleChangeTextarea={this.handleChangeTextarea}
                  checkedAnswers={checkedAnswers}
                  scores={scores}
                  completedQuiz={completedQuiz}
                  companyDetail={companyDetail}
                  frontpageObject={frontpageObject}
                
                 />
            </Container>
        }

        {
          homepage === true 
            && isFinished === false 
            && frontpageObject 
            && 
              <>
                <Hero     
                  frontpageObject={frontpageObject}  
                  image={MainImg}
                >
                  <Switch value={'HeroBlock'}>
                    <div value={'HeroBlock'}><HeroBlock frontpageObject={frontpageObject} toQuiz={() => this.changeQuiz(0)} /></div>
                    <div value={'FAQ'}><FaqContent /></div>
                  </Switch>
                </Hero>
              </>
        }

      </React.Fragment>
    )
  }
}

